import { LinkAdapter, LinkAdapterProps } from '@gaiads/telia-react-component-library';
import { Link } from 'react-router-dom';

export const RouterLinkAdapter: LinkAdapter = ({ to, children, ...props }: LinkAdapterProps) => {
  return (
    <Link to={to ? (to as string) : '#'} {...props}>
      {children}
    </Link>
  );
};
